import React from 'react';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home.js';
import AboutMe from './components/AboutMe.js';
import Portfolio from './components/Protfolio.js';
import Projects from './components/Projects.js';
import Featured from "./components/Featured.js";
import Contact from './components/Contact.js';
import Footer from './components/Footer.js';
// import CreateProject from './components/createProject.js'; 
import NothingPage from './components/errorPage.js';
// import Aamdin from './components/Aamdin.js';
// import Login from './components/Login.js';
// import Register from './components/Register.js';

import "./fonts/AceAttitude-Regular.ttf";
import "./fonts/AceAttitude-Bold.ttf";
import "./fonts/AceAttitude-ExtraBold.ttf";
import "./fonts/AceAttitude-Black.ttf";
import "./fonts/AceAttitude-Thin.ttf";
import "./fonts/AceAttitude-Light.ttf";
import "./fonts/AceAttitude-Medium.ttf";
// import ProtectedRoute from './components/ProtectedRoute.js';

function App() {

  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path = "/projects/create" element={
              <ProtectedRoute redirectPath="/projects"> 
                <CreateProject/>
              </ProtectedRoute>}
            />  */}
            {/* <Route path="/aamdin" element={
                <ProtectedRoute redirectPath="/">
                  <Aamdin />
                </ProtectedRoute>
              } 
            /> */}
            {/* <Route path='/authl' element={ <Login /> } />
            <Route path='/authr' element={ <Register /> } /> */}
            <Route path="/about" element={<AboutMe />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/projects" element={<Projects />} />
            
            <Route path="/featured" element={<Featured />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NothingPage />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
